export const bedListColumn = [
    {
        Header: 'Bed Id',
        accessor: 'bedId',
    },
    {
        Header: 'Bed Name',
        accessor: 'bedName',
    },
    {
        Header: 'Actions',
        accessor: 'actions',
    }
]

export const bedListTableData = [
    {
        "bedId": "1101",
        "bedName": "King Bed",
    },
    {
        "bedId": "1102",
        "bedName": "Queen Bed",
    },
    {
        "bedId": "1103",
        "bedName": "Twins Bed",
    },
    {
        "bedId": "1104",
        "bedName": "Electric Bed",
    },
    {
        "bedId": "1105",
        "bedName": "Futon Bed",
    },
    {
        "bedId": "1106",
        "bedName": "Mattress Bed",
    },
    {
        "bedId": "1107",
        "bedName": "Air Bed",
    },
]